import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Salatou } from '../../types';

export type State = Salatou[];

const initialState: State = [];

export const SalatouSlice = createSlice({
  name: 'salatous',
  initialState,
  reducers: {
    onSetSalatou: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeleteSalatou: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetSalatou, onDeleteSalatou } = SalatouSlice.actions;

export default SalatouSlice.reducer;
